<template>
  <v-navigation-drawer
    :mini-variant.sync="isMini"
    permanent
    touchless
    expand-on-hover
    app
    class="pa-0"
    :width="300"
  >
    <v-list dense>
      <v-list-item>
        <v-list-item-avatar size="30px" class="mb-3">
          <v-img src="@/assets/favicon.png" />
        </v-list-item-avatar>

        <v-list-item-title>
          <div class="d-flex">
            <v-btn icon @click="handleLogout">
              <v-icon v-text="'mdi-logout'" />
            </v-btn>
            <div style="display: flex; flex-flow: column">
              <div>
                {{
                  currentUser
                    ? `${
                        isGlobalLocale && currentUser.lastNameI18n
                          ? currentUser.lastNameI18n
                          : currentUser.lastName
                      } ${
                        isGlobalLocale && currentUser.firstNameI18n
                          ? currentUser.firstNameI18n
                          : currentUser.firstName
                      }`
                    : ''
                }}
              </div>
              <div>
                {{
                  currentUser
                    ? isGlobalLocale && currentUser.role.titleI18n
                      ? currentUser.role.titleI18n
                      : currentUser.role.title
                    : ''
                }}
              </div>
            </div>
          </div>
        </v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <nav-drawer-list />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

import { PURGE_AUTH } from '@/store/mutations.type'

import NavDrawerList from './NavDrawerList.vue'

export default {
  components: { NavDrawerList },
  name: 'LeftPanelNavDrawer',
  data() {
    return {
      isMini: true
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isGlobalLocale'])
  },
  methods: {
    handleLogout() {
      this.$store.commit(PURGE_AUTH)
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>
